import { Component, OnInit,ViewChildren,QueryList, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { APIComplaintsService } from '../../_services/complaints/API-complaints';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/filter';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import * as crypto from 'crypto-js';
import { APIEncryptionDecryption } from '../../_services/CommonService/API-Common-Service';
import { map } from 'rxjs/operators';
import { formatDate } from '@angular/common';
import { saveAs } from 'file-saver/src/FileSaver';

@Component({
  selector: 'app-complaints-summary',
  templateUrl: './complaints-summary.component.html',
  styleUrls: ['./complaints-summary.component.css']
})
export class ComplaintsSummaryComponent implements OnInit {
  complaints: any;
  
  //dataSource: MyDataSource | null;

  
  // displayedColumns: string[] = ['Complaint_No', 'MobileNo', 'ComplaintDate', 'ComplaintDesc', 'IncidentDate', 'TypeOfUCC', 
  // 'TM_No_Header', 'TSP_Name', 'T_Unique_Ref_No', 'O_Action_Taken', 'T_Complaint_Status'];
	
  dataSubject = new BehaviorSubject<any[]>([]);
	displayedColumns: string[] = ['Complaint_No', 'MobileNo', 'ComplaintDate', 'ComplaintDesc', 'IncidentDate', 'TypeOfUCC', 
    'TM_No_Header','Status'];
	displayedColumns1: string[] = ['Complaint_No', 'MobileNo', 'ComplaintDate', 'ComplaintDesc', 'IncidentDate', 'TypeOfUCC', 
    'TM_No_Header','Status'];

  GetDND_COMPLAINTS_TSP: any;
  complaintsArray: any[];
  mobile: any;
  Virtual_MobileNo: any;
  decrypted_mob: any;

  dataSource: MatTableDataSource<any>;
  noRecord: any;
  dataSource1: MatTableDataSource<any>;
  noRecord1: any;
  filterData: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('sort2') sort2: MatSort;
  form1: any = {};

  constructor(
    private tc: APIComplaintsService,
    private db: $DBManagerService,
    private encryDecry : APIEncryptionDecryption,
    ) {

	this.getDNDComplaints();
	
	}
	applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
     getDNDComplaints(){
     this.tc.GetDND_COMPLAINTS_TSP().subscribe({
      next: value => {
        this.dataSubject.next(value);
         console.log("Value",value);
         value.map((val, i) => {

         // console.log("val.MobileNo :",val.MobileNo);
         // this.decrypted_mob=this.encryDecry.decrypt_mobile(val.Virtual_MobileNo.trim())
         // console.log("decrypted_mob in compalint-summary components : ",this.decrypted_mob);
          //value[i].MobileNo = val.MobileNo;
        })
        this.onChangeDataSource(value);
        console.log("hello",value)
      }
    }); 


  }
  onChangeDataSource(value){
    this.dataSource = new MatTableDataSource(value);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort=this.sort;
    this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));
    console.log("dataSource : ", this.dataSource);
    console.log("value2",value);

  }
  
  
 

  ngOnInit() {
    this.mobile = this.db.get(Constants.SESSSION_STORAGE, Constants.MOBILE_NO);
  }

  onSubmitFilter(filterForm) {
    console.log(filterForm.value);

    const fdate = formatDate(filterForm.startDate, 'dd-MM-yyyy', 'en-US', '+0530');
    const ldate = formatDate(filterForm.endDate, 'dd-MM-yyyy', 'en-US', '+0530');
    console.log("fdate",fdate);
    console.log("ldate",ldate);

    this.getAllComplaintsFilter(filterForm.search,fdate,ldate);
  }

  getAllComplaintsFilter(param1,fdate,todate){
    console.log("inside main function ");

    console.log("inside main function "+param1+"$$$"+fdate+"$$$$"+todate);
    this.tc.getComplaintsFilter(param1,fdate,todate)
    .subscribe(r => {
      this.filterData = r;
	  console.log("this.filterData ::: ",this.filterData);
      var filterArray = [];

       r.forEach(i => {
       // this.decrypted_mob=this.encryDecry.decrypt_mobile(i.Record.Virtual_MobileNo.trim())
       // console.log("fileterd decrypted_mob in compalint-summary components : ",this.decrypted_mob);
     //  i.Record.Virtual_MobileNo = this.decrypted_mob;
      //  console.log("item",i);
        filterArray.push(i);
         this.onChangeDataSource(filterArray);
       });
	   console.log("this.filterData.length : ", this.filterData.length)
       this.dataSource = r;
	this.onChangeDataSource(r);      
    }) 

  }

//reseting the datat in the table

reset()
{
console.log("reset is working");
  this.getDNDComplaints();
}


// download the file function

downloadCsv(downloadForm)
{
  const fdate = formatDate(downloadForm.startDate, 'yyyy-MM-dd', 'en-US', '+0530');
    const ldate = formatDate(downloadForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530');
  var data={

    "Search_By":downloadForm.searchBy,
    "Search":downloadForm.search,
    "Option":downloadForm.downloadOption,
    "Start_Date":fdate,
    "End_Date":ldate

  }
  console.log("the download data is",data);

  this.tc.downloadComplaints(data)
  .subscribe(r=>{
    var blob = new Blob([r], {type: 'text/csv' })
    const today = new Date();
    var ranvalue = today.getTime();
    var fileName = ranvalue+'.csv';
    saveAs(blob, fileName); 
   // saveAs(blob, "myFile.csv"); 
 console.log("downloading goes here",r);
  })
}
}

export class MyDataSource extends DataSource<any[]> {

  constructor(private subject: BehaviorSubject<any[]>) {
    super();
  }
  connect(): Observable<any[]> {
    return this.subject.asObservable();
  }
  disconnect(): void {

  }



}




